const tagManagerConfig = {
  development: {
    gtmId: 'GTM-WD7VJQ9'
  },
  homolog: {
    gtmId: 'GTM-WD7VJQ9'
  },
  test: {
    gtmId: 'GTM-WD7VJQ9'
  },
  production: {
    gtmId: 'GTM-KT766LL'
  }
}

export default tagManagerConfig[process.env.REACT_APP_NODE_ENV]
